import { propertyHistoryMappings } from 'helpers/research/research_info_mappings';

export const propertyInformationMappings = {
  buildingClass: 'Building Class',
  buildingSizeLabel: 'Building Size (SF)',
  city: 'City',
  dealStatusLabel: 'Availability',
  lotSize: 'Lot Size',
  numberOfUnits: 'Number of Units',
  ownerName: 'Owner Name',
  ownerEmail: 'Owner Email',
  ownerPhoneNumber: 'Owner Phone',
  propertySubtypeLabel: 'Property Subtype',
  propertyType: 'Property Types',
  investmentType: 'Investment Type',
  renovated: 'Year Renovated',
  state: 'State',
  databaseName: 'Database',
  yearBuilt: 'Year Built',
  zip: 'Zip Code'
};

export const leaseInformationMappings = {
  landlordString: 'Landlord',
  leaseRateLabel: 'Lease Rate',
  leaseDate: 'Lease Start',
  leaseExecutionDate: 'Lease Execution',
  leaseExpirationDate: 'Lease Expiration',
  spaceTypeName: 'Lease Space Type',
  sizeLabel: 'Lease Size (SF)',
  tenantString: 'Tenant',
  tenantContactString: 'Tenant Contact'
};

export const saleInformationMappings = {
  capRatePct: 'Sale Cap Rate',
  price: 'Sale Price',
  pricePerSf: 'Sale Price Per SF',
  pricePerUnit: 'Sale Price Per Unit',
  saleDate: 'Sale Date',
  buyerName: 'Buyer',
  sellerName: 'Seller'
};

export const compsInformationMappings = {
  propertyInformation: {
    title: 'Property Information',
    mappings: propertyInformationMappings,
    key: 'property-information'
  },
  saleInformation: {
    title: 'Sale Comp Information',
    mappings: saleInformationMappings,
    key: 'sale-information'
  },
  leaseInformation: {
    title: 'Lease Comp Information',
    mappings: leaseInformationMappings,
    key: 'lease-information'
  },
  historyInformation: {
    title: 'History',
    mappings: propertyHistoryMappings,
    key: 'history-information'
  }
};

export const defaultSaleColumnMappings = {
  name: 'Property Name / Address'
};

export const defaultLeaseColumnMappings = {
  name: 'Property Name / Address',
  suite: 'Space/Suite Name'
};

export const getDefaultColumnMappings = saleOrLease => (
  saleOrLease === 'lease' ? defaultLeaseColumnMappings : defaultSaleColumnMappings
);
